import { map } from 'rxjs/operators';
import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter, HostBinding } from '@angular/core';
import { LegendListProviderService } from 'src/app/services/legend-list-provider.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { TreeComponent } from '@circlon/angular-tree-component';
import { LegendClassComponent } from './legend-item/legend-class/legend-class.component';
import { LegendItemComponent } from './legend-item/legend-item.component';
import { Decorable } from 'src/app/types/decorable';
import { DisplayAction } from 'src/app/model/map-actions/display-actions';

@Component({
  selector: 'app-legend-view',
  templateUrl: './legend-view.component.html',
  styleUrls: ['./legend-view.component.scss']
})
export class LegendViewComponent implements OnInit {
  public nodes = [];
  public expanded = true;
  public ready = false;
  public options = {
    scrollContainer: $('app-legend-view')[0]
  };
  @ViewChild('tree', { static: true }) tree: TreeComponent;
  @Output() viewChange: EventEmitter<any> = new EventEmitter();
  @HostBinding('class.collapsed') get collapsed() {
    return !this.expanded;
  }
  constructor(private domNode: ElementRef, private listProvider: LegendListProviderService) { }

  ngOnInit() {
  }
  HandleExtras(params: any) {
    if (params.hasOwnProperty('spanelExpanded')) {
      this.expanded = params.spanelExpanded;
      if (this.ready === true) {
        this.SetInitialExpansion();
      }
    }
  }
  ShowLegend(layers: Array<SLLayer>, expand = true) {
    this.nodes = [];
    this.ready = false;
    window.requestAnimationFrame(() => {
      this.nodes = this.listProvider.GetTreeView(layers);
      setTimeout(() => {
        this.tree.treeModel.expandAll();
        if (expand) {
          this.SetInitialExpansion();
        }

      }, 100);
      this.ready = true;
    });
  }

  SetInitialExpansion() {
    if ((this.ready === false) || (!this.tree.treeModel.getNodeById(0))) {
      window.requestAnimationFrame(() => {
        this.SetInitialExpansion();
      })
      return;
    }

    if (this.expanded === true) {
      this.tree.treeModel.getNodeById(0).expand();
    } else {
      this.tree.treeModel.getNodeById(0).collapse();
    }

  }
  isHeading(node: any, index: any): boolean {
    index = index;
    if (node?.data?.type) {
      return node.data.type === 'heading';
    }
    if (node?.data?.id === 'results') {
      return true;
    }
    return false;
  }
  HandleViewChange() {
    window.requestAnimationFrame(() => {
      this.viewChange.emit({ view: this });
    })

  }

  onResized() {
    this.HandleViewChange();
  }
  UpdateHeight(height: number, panelMax: number) {
    height = height;
    if (this.expanded) {
      this.domNode.nativeElement.style.setProperty('--panel-offset', '0px');
    } else {
      this.domNode.nativeElement.style.setProperty('--panel-offset', (panelMax - 20) + 'px');
    }
    this.domNode.nativeElement.style.setProperty('max-height', "calc(' + panelMax + 'px - var(--panel-offset)) !important");
  }
  Expand(isExpanded: boolean = true) {
    this.expanded = isExpanded;
    if (this.expanded === true) {
      this.tree.treeModel.getNodeById(0).expand();
    } else {
      this.tree.treeModel.getNodeById(0).collapse();
    }
    this.tree.treeModel.update();

  }
  ToggleExpanded(expanded?: boolean) {
    if (expanded === undefined) expanded = !this.expanded;
    this.Expand(expanded);


  }
  Toggle(node: any, event: any) {
    event.stopImmediatePropagation();
    event.preventDefault;

    const expandable = [0,'results'].indexOf(node.id) > -1;
    if (expandable) {
      if (node.isExpanded) {
        node.collapse();
      } else {
        node.expand();
      }
      DisplayAction.UpdatePanels();
    } else {

      node.mouseAction('click', event)
    }
  }
  GetLegendData() {
    const data = {};
    for (const node of this.nodes[0].children) {
      if (!!node.layer && (!(!!node.layer.legendary && !!node.layer.includeInLegend) && !node.layer.layerOn)) {
        continue;
      }
      data[node.layer.name] = this.ProcessLegendNode(node);
    }
    return data;
  }
  ProcessLegendNode(node: any): any {
    if (!!node.layer && (!(!!node.layer.legendary && !!node.layer.includeInLegend) && !node.layer.layerOn)) {
      return null;
    }
    const processed: any = {};
    if (!!node.children) {
      processed[node.layer.name] = [];
      for (const child of node.children) {
        const processedNode = this.ProcessLegendNode(child);
        if (processedNode !== null) {
          processed[node.layer.name][child.layer.name] = processedNode;
        }
      }
      return processed;
    }
    if (!!node.component && !!node.component.legend) {
      const legend: any[] = [];
      for (const legendEntry of node.component.legend) {
        const legendClass: LegendClassComponent = legendEntry.component as LegendClassComponent;
        legend.push({ name: legendClass.item.class_name, swatch: legendClass.GetSwatchURL() });

      }
      return legend;
    }
    return processed;
  }
}
